// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tabClass[data-v-6c9d7d11] {\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
